var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1169 9.48645C13.9304 10.698 12.8315 12.1346 12 13.7952C11.4305 12.6577 10.7354 11.6252 9.97273 10.6982C9.46966 7.77518 8.83321 5.30275 8.31508 3.63427C8.18026 3.20013 8.64778 2.82793 9.03412 3.08376C10.8905 4.31309 13.2603 6.45925 15.1169 9.48645Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94099 6.92388C6.40412 8.72145 11.6079 12.9773 11.979 19.513H12.021C12.3921 12.9773 17.5959 8.72145 21.059 6.92388C21.4691 6.71101 21.9025 7.12412 21.7387 7.54597C21.1516 9.05735 20.4362 11.3169 19.9343 13.9515C18.5296 15.0197 16.9074 16.8755 16.6419 19.513H18.1859C18.4587 17.3501 19.8849 15.8167 21.1132 14.952C21.4896 14.6871 21.9371 15.0691 21.8053 15.5013C21.4927 16.5266 21.1667 17.9636 21.0834 19.513H22.2326C22.6564 19.513 23 19.8459 23 20.2565C23 20.6671 22.6564 21 22.2326 21H1.76744C1.3436 21 1 20.6671 1 20.2565C1 19.8459 1.3436 19.513 1.76744 19.513H2.62272C2.55735 18.3773 2.3546 17.3209 2.14709 16.5163C2.03406 16.078 2.49171 15.7264 2.83938 16.0274C3.67852 16.7541 4.56888 17.9238 4.78692 19.513H6.33243C6.13435 17.6718 5.2308 16.2726 4.30232 15.3312C3.81163 12.1098 2.94863 9.31527 2.26133 7.54597C2.09746 7.12412 2.53089 6.71101 2.94099 6.92388Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.3ae69160ddca47dc1b8a2f3cf5f9263f.svg";
export { ForwardRef as ReactComponent };